import React, { useEffect } from 'react';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { translationClasses } from 'src/shared/TranslationClasses';
import { C40SimpleSignUpProps } from './C40SimpleSignUp.types';
import { CreateSimpleSignUpModel } from './C40SimpleSignUp.service';
import { Form, SimpleSignup } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { getDroplink } from 'src/shared/param-utils';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C40SimpleSignUpProps): JSX.Element => {
  const { params, fields } = props || {};
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const formioProjectURL = process.env.NEXT_PUBLIC_GLOBAL_FORMIO_PROJECT_URL || '';
  const formioScript = 'https://formio-prod-cdn.azureedge.net/scripts/hse.forms.min.js';
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  useEffect(() => {
    const loadCreateForm = () => {
      return new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = formioScript;
        script.type = 'module';
        script.async = true;

        script.onload = () => {
          if (typeof window.createForm === 'function') {
            resolve();
          } else {
            reject(new Error('createForm is not defined on window'));
          }
        };

        script.onerror = () => {
          reject(new Error('Failed to load the createForm script'));
        };

        document.body.appendChild(script);
      });
    };

    loadCreateForm()
      .then(() => {
        // Now it's safe to use window.createForm
        window.createForm(`${fields?.FormID?.value}`, {
          redirect: `/`,
          formProjectUrl: `${formioProjectURL}`,
        });
      })
      .catch((error) => {
        console.error(error);
      });

    // Cleanup script on component unmount
    return () => {
      const script = document.querySelector(`script[src="${formioScript}"]`);
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, [fields?.FormID?.value, formioProjectURL]);

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }
  if (isEditing) {
    return (
      <SimpleSignup
        {...CreateSimpleSignUpModel(props)}
        className={translationClasses(params)}
        id={params?.AnchorLinkTargetName}
      >
        <p>
          <b>Form Name:</b> <Text field={fields?.FormID} />
        </p>
      </SimpleSignup>
    );
  }

  return (
    <SimpleSignup
      {...CreateSimpleSignUpModel(props)}
      className={translationClasses(params)}
      id={params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    >
      <Form data-alignment={getDroplink(props?.rendering?.params?.Alignment)} />
    </SimpleSignup>
  );
};
